import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  }
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export function money(n) {
  const v = Number(n || 0);
  return `$${v.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

export function categoryLabel(c) {
  const map = {
    mixed: "MIXED",
    estate: "ESTATE",
    household: "HOUSEHOLD",
    tools: "TOOLS",
    commercial: "COMMERCIAL",
    collectibles: "COLLECTIBLES",
  };
  return map[c] || String(c || "").toUpperCase();
}
